"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _deprecate = require("@nerdwallet/deprecate");

var _useIconProps = require("../useIconProps");

var Navigateright = function Navigateright(props) {
  (0, _deprecate.useDeprecatedComponentWarning)({
    component: 'Navigateright'
  });
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 2048 2048"
  }, (0, _useIconProps.useIconProps)(props)), /*#__PURE__*/_react.default.createElement("path", {
    d: "M825 1732l-114-113 605-605-605-605 114-113 718 718z"
  }));
};

Navigateright.displayName = 'Navigateright';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Navigateright.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

var _default = Navigateright;
exports.default = _default;